(function () {
  const FALLBACK_COUNT = '100,000';
  const TIMEOUT_MS = 5000;

  function getFiveStarCount(aggregateData) {
    const aggregate = aggregateData?.reviewAggregate;
    if (!aggregate) return null;

    const fiveStarCount =
      aggregate.reviewCountByLevel?.level5Count ??
      aggregate.ratingAndReviewCountByLevel?.level5Count;

    if (fiveStarCount != null) return Number(fiveStarCount);
    if (aggregate.reviewCount != null) return Number(aggregate.reviewCount);

    return null;
  }

  async function fetchPromoBannerReviewCount(el) {
    const okendoUserId = el.dataset.okendoUserId;
    if (!okendoUserId) return;

    const fallbackTimer = setTimeout(() => {
      if (!el.textContent.trim()) el.textContent = `Over ${FALLBACK_COUNT}`;
    }, TIMEOUT_MS);

    try {
      const controller = new AbortController();
      const abortTimer = setTimeout(() => controller.abort(), TIMEOUT_MS);

      const res = await fetch(
        `https://api.okendo.io/v1/stores/${encodeURIComponent(okendoUserId)}/review_aggregate`,
        { signal: controller.signal }
      );

      clearTimeout(abortTimer);
      clearTimeout(fallbackTimer);

      if (res.ok) {
        const data = await res.json();
        const total = getFiveStarCount(data);
        if (total) {
          el.textContent = `Over ${total.toLocaleString('en-US')}`;
        } else {
          el.textContent = `Over ${FALLBACK_COUNT}`;
        }
      } else {
        el.textContent = `Over ${FALLBACK_COUNT}`;
      }
    } catch (error) {
      clearTimeout(fallbackTimer);
      el.textContent = `Over ${FALLBACK_COUNT}`;
      if (error.name !== 'AbortError') console.error('Promotion banner reviews count error:', error);
    }
  }

  document.querySelectorAll('[data-promotion-banner-count]').forEach(fetchPromoBannerReviewCount);
})();
